/**/
import React from "react"
import {withRouter} from 'react-router-dom'
import {Button, Card, Col, Icon, Input, message, Row, Spin, Table, Tabs, Tag, Typography} from "antd"
import {API, Auth} from "aws-amplify"
import BaseAdminLite from "./BaseAdminLite"
import moment from 'moment'
import {connect} from "react-redux"
import {CustomSpinner} from "../../Components/Spin/CustomSpiner"
import {allDispatch as mapDispatchToProps, allState as mapStateToProps} from "../../Redux/Selectors"
import {CSVLink} from "react-csv";

const {Text} = Typography;
const {TabPane} = Tabs;
const {Search} = Input;

class DashboardAdminLite extends React.Component {


    constructor(props) {
        super(props)
        this.state = {
            usuarios: [],
            loading_alta: true,
            loading_pending: true,
            loading_payment: true,
            users_count: {},
            loading_uncomplete: true,
            loading_count: true,
            loading_baja: true,
            loading_todos: true,
            usuarios_alta: [],
            usuarios_baja: [],
            usuarios_todos: [{}],
            usuarios_pending: [],
            usuarios_payment: [],
            usuarios_uncomplete: [],
            last_user_id: null
        }
    }

    componentDidMount = async () => {

        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/admindashboard',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        this.setState({loading_count: false, users_count: response})
                    })
            })
            .catch(err => {
                    // console.log(err)
                    message.error('Sesion vencida, vuelve a loguearte por favor')
                    this.props.Logout()
                    this.props.history.push('/login')
                }
            )

            .catch(err => {
                message.error('Sesion vencida, vuelve a loguearte por favor')
                this.props.Logout()
                this.props.history.push('/login')
            })

        await this.loadUserData();

        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/admindashboard/relationship/users/'+this.userData.cuit,
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        const relationships = response.relationships;
                        let usuariosAlta = relationships.map(usr => {
                            usr["key"] = usr["emailUsuario"]
                            return usr
                        })
                        this.setState({
                            loading_alta: false,
                            usuarios_alta: usuariosAlta
                        })
                    })
                    .catch(err => console.log(err))
            })
    }

    loadUserData = async () => {
        const [response, user] = await Promise.all([
            Auth.currentSession(),
            Auth.currentUserInfo()
        ]);

        this.userData = await API.get(
            'test',
            '/root/admindashboard/' + user.username,
            {
                headers: {
                    Authorization: response.getIdToken().getJwtToken()
                }
            }
        );
    }


    render() {
        if (this.state.loading_alta ){
            return (
                <BaseAdminLite selected='admin-lite'>
                    <Row type="flex" justify="space-around" align="middle">
                        <Col style={{minHeight: '360px'}}>
                            <Spin indicator={CustomSpinner}/>
                        </Col>
                    </Row>
                </BaseAdminLite>
            )
        } else {


            let columns = [
                {
                    title: "CUIT",
                    dataIndex: "cuitUsuario",
                    key: "cuitUsuario",
                    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                        <div style={{padding: 8}}>
                            <Input
                                ref={node => {
                                    this.searchInput = node;
                                }}
                                placeholder="Buscar usuario"
                                value={selectedKeys[0]}
                                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                                onPressEnter={() => confirm()}
                                style={{width: 188, marginBottom: 8, display: 'block'}}
                            />
                            <Button
                                type="primary"
                                onClick={() => confirm()}
                                icon="search"
                                size="small"
                                style={{width: 90, marginRight: 8}}
                            >
                                Buscar
                            </Button>
                            <Button
                                onClick={() => clearFilters()}
                                size="small"
                                style={{width: 90}}
                            >
                                Reset
                            </Button>
                        </div>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
                    ),
                    onFilter: (value, record) => (record.cuitUsuario + '').toLowerCase().includes(value),
                    onFilterDropdownVisibleChange: visible => {
                        if (visible) {
                            setTimeout(() => this.searchInput.select())
                        }
                    }
                },
                {
                    title: "Usuario",
                    dataIndex: "emailUsuario",
                    key: "emailUsuario",
                    width: "20em",
                    //fixed: "left",
                    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                        <div style={{padding: 8}}>
                            <Input
                                ref={node => {
                                    this.searchInput = node;
                                }}
                                placeholder="Buscar usuario"
                                value={selectedKeys[0]}
                                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                                onPressEnter={() => confirm()}
                                style={{width: 188, marginBottom: 8, display: 'block'}}
                            />
                            <Button
                                type="primary"
                                onClick={() => confirm()}
                                icon="search"
                                size="small"
                                style={{width: 90, marginRight: 8}}
                            >
                                Buscar
                            </Button>
                            <Button
                                onClick={() => clearFilters()}
                                size="small"
                                style={{width: 90}}
                            >
                                Reset
                            </Button>
                        </div>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
                    ),
                    onFilter: (value, record) => record.emailUsuario.toString().toLowerCase().includes(value),
                    onFilterDropdownVisibleChange: visible => {
                        if (visible) {
                            setTimeout(() => this.searchInput.select())
                        }
                    }
                },
                {
                    title: "Apellido",
                    dataIndex: "apellidoUsuario",
                    key: "apellido",
                    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                        <div style={{padding: 8}}>
                            <Input
                                ref={node => {
                                    this.searchInput = node;
                                }}
                                placeholder="Buscar usuario"
                                value={selectedKeys[0]}
                                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                                onPressEnter={() => confirm()}
                                style={{width: 188, marginBottom: 8, display: 'block'}}
                            />
                            <Button
                                type="primary"
                                onClick={() => confirm()}
                                icon="search"
                                size="small"
                                style={{width: 90, marginRight: 8}}
                            >
                                Buscar
                            </Button>
                            <Button
                                onClick={() => clearFilters()}
                                size="small"
                                style={{width: 90}}
                            >
                                Reset
                            </Button>
                        </div>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
                    ),
                    onFilter: (value, record) => record.apellidoUsuario.toString().toLowerCase().includes(value),
                    onFilterDropdownVisibleChange: visible => {
                        if (visible) {
                            setTimeout(() => this.searchInput.select())
                        }
                    }
                },
                {
                    title: "Nombre",
                    dataIndex: "nombreUsuario",
                    key: "nombre",
                    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                        <div style={{padding: 8}}>
                            <Input
                                ref={node => {
                                    this.searchInput = node;
                                }}
                                placeholder="Buscar usuario"
                                value={selectedKeys[0]}
                                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                                onPressEnter={() => confirm()}
                                style={{width: 188, marginBottom: 8, display: 'block'}}
                            />
                            <Button
                                type="primary"
                                onClick={() => confirm()}
                                icon="search"
                                size="small"
                                style={{width: 90, marginRight: 8}}
                            >
                                Buscar
                            </Button>
                            <Button
                                onClick={() => clearFilters()}
                                size="small"
                                style={{width: 90}}
                            >
                                Reset
                            </Button>
                        </div>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
                    ),
                    onFilter: (value, record) => record.nombreUsuario.toString().toLowerCase().includes(value),
                    onFilterDropdownVisibleChange: visible => {
                        if (visible) {
                            setTimeout(() => this.searchInput.select())
                        }
                    }
                },
                {
                    title: "Teléfono",
                    dataIndex: "telefonoUsuario",
                    key: "telefono"
                },
                {
                    title: "Estado",
                    dataIndex: "estadoUsuario",
                    key: "estadoUsuario",
                    render: (value) => {
                        let color = ""
                        let text = ""
                        switch (value) {
                            case "ACTIVO":
                                color = "green"
                                text = "Activo"
                                break
                            case "INCOMPLETO":
                                color = "grey"
                                text = "Incompleto"
                                break
                            case "BAJA":
                                color = "red"
                                text = "Baja"
                                break
                            case "INACTIVO":
                                color = "orange"
                                text = "Inactivo"
                                break
                            case "BLOQUEADO":
                                color = "yellow"
                                text = "Bloqueado"
                                break
                            default:
                                text = value;
                                break
                        }
                        return {
                            children:
                                <Tag>
                                    {text}
                                </Tag>
                        }
                    },
                    filters: [
                        {
                            text: "Activo",
                            value: "ACTIVO"
                        },
                        {
                            text: "Baja",
                            value: "BAJA"
                        },
                        {
                            text: "Bloqueado",
                            value: "BLOQUEADO"
                        },
                        {
                            text: "Inactivo",
                            value: "INACTIVO"
                        },
                        {
                            text: "Incompleto",
                            value: "INCOMPLETO"
                        }

                    ],
                    filterMultiple: true,
                    onFilter: (value, record) => record.estadoUsuario.indexOf(value) === 0
                },
                {
                    title: "Código",
                    dataIndex: "codigo",
                    key: "codigo",
                    filterDropdown: ({setSelectedKeys, selectedKeys, confirm, clearFilters}) => (
                        <div style={{padding: 8}}>
                            <Input
                                ref={node => {
                                    this.searchInput = node;
                                }}
                                placeholder="Buscar usuario"
                                value={selectedKeys[0]}
                                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                                onPressEnter={() => confirm()}
                                style={{width: 188, marginBottom: 8, display: 'block'}}
                            />
                            <Button
                                type="primary"
                                onClick={() => confirm()}
                                icon="search"
                                size="small"
                                style={{width: 90, marginRight: 8}}
                            >
                                Buscar
                            </Button>
                            <Button
                                onClick={() => clearFilters()}
                                size="small"
                                style={{width: 90}}
                            >
                                Reset
                            </Button>
                        </div>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{color: filtered ? '#1890ff' : undefined}}/>
                    ),
                    onFilter: (value, record) => record.codigo ? (record.codigo + '').includes(value) : record.codigo,
                    onFilterDropdownVisibleChange: visible => {
                        if (visible) {
                            setTimeout(() => this.searchInput.select())
                        }
                    }
                },
                {
                    title: "Acciones",
                    dataIndex: "actions",
                    key: "actions",
                    render: (text, record, index) => {
                        return {
                            children: <Button disabled={true} onClick={() => this.props.history.push("/edit-user/" + record.user_id)}>
                                Editar
                            </Button>
                        }
                    }
                },

            ]


            let usuariosAltaPorHacer = this.state.usuarios_alta;

            return (


                <BaseAdminLite
                    selected="admin-lite"
                >

                    <Row gutter={[8, 8]} type="flex">
                        <Col lg={6} xs={24}>
                            <Card
                                title={'Usuarios activos'}
                                style={{height: '100%'}}
                            >
                                <Text strong>{usuariosAltaPorHacer.filter(u => u.estadoUsuario === 'ACTIVO').length} Usuarios</Text>

                            </Card>
                        </Col>
                        <Col lg={6} xs={24}>
                            <Card
                                title={'Metricas'}
                                style={{height: '100%'}}
                            >
                                <Text strong>-</Text>
                            </Card>
                        </Col>
                        <Col lg={6} xs={24}>
                            <Card
                                title={'Metricas'}
                                style={{height: '100%'}}
                            >
                                <Text strong>-</Text>
                            </Card>
                        </Col>
                        <Col lg={6} xs={24}>
                            <Card
                                title={'Metricas'}
                                style={{height: '100%'}}
                            >
                                <Text strong>-</Text>
                            </Card>
                        </Col>
                    </Row>
                    <Card style={{marginTop: '10px'}}>
                        <Row>
                            <Col lg={24}>
                                <Table
                                    columns={columns}
                                    dataSource={usuariosAltaPorHacer}
                                    pagination={{
                                        showSizeChanger: true,
                                        pageSizeOptions: ['5', '10', '20', '50', '100'],
                                        defaultPageSize: 5,
                                        hideOnSinglePage: true
                                    }}
                                    onChange={
                                        (pagination, filters, sorter, extra) => {
                                            this.setState({currentData: extra.currentDataSource})
                                        }
                                    }
                                    loading={this.state.loading_alta}
                                    scroll={{x: "max-content"}}
                                />
                            </Col>
                        </Row>
                        <CSVLink
                            style={{marginTop: 15}}
                            data={this.state.currentData ? this.state.currentData : usuariosAltaPorHacer}
                            headers={headers}
                            filename={"usuarios.csv"}
                        >
                            Descargar  CSV
                        </CSVLink>
                    </Card>
                </BaseAdminLite>

            );
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DashboardAdminLite));

let headers = [
    {
        title: "CUIT",
        label: "CUIT",
        dataIndex: "cuitUsuario",
        key: "cuitUsuario",
    },
    {
        title: "Usuario",
        label: "Usuario",
        dataIndex: "emailUsuario",
        key: "emailUsuario",
        width: "20em",
    },
    {
        title: "Apellido",
        label: "Apellido",
        dataIndex: "apellidoUsuario",
        key: "apellidoUsuario",
    },
    {
        title: "Nombre",
        label: "Nombre",
        dataIndex: "nombreUsuario",
        key: "nombreUsuario",
    },
    {
        title: "Teléfono",
        label: "Teléfono",
        dataIndex: "telefonoUsuario",
        key: "telefonoUsuario"
    },
    {
        title: "Estado",
        label: "Estado",
        dataIndex: "estadoUsuario",
        key: "estadoUsuario",
    },
    {
        title: "Código",
        label: "Código",
        dataIndex: "codigo",
        key: "codigo",
    },

]
